import { BundleCheckList, CategoryType } from "@stepapp/core/apiTypes";
import { Block, CollapsibleChecklist, Typography } from "@stepapp/ui";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  date: string;
  instantPayment: boolean;
  categoryType?: CategoryType | null;
};

const CancellationDetails = ({
  instantPayment,
  date,
  categoryType = CategoryType.Cleaning,
}: Props) => {
  const { t } = useTranslation();
  const cancellationRulesDescription = instantPayment
    ? t("pages.serviceSummary.instantPaymentRules")
    : t("pages.serviceSummary.cancellationRulesDescription", { date });

  const cancellationDetails: BundleCheckList[] = useMemo(
    () => [
      {
        title: t("pages.serviceSummary.nextSteps"),
        description: `<p>${t("pages.serviceSummary.nextStepsDescription", { context: categoryType?.toLowerCase() })}</p>`,
        iconUrl: "info",
      },
      {
        title: t("pages.serviceSummary.cancellationRules"),
        description: `<p>${cancellationRulesDescription}</p>`,
        iconUrl: "info",
      },
      {
        title: t("pages.serviceSummary.doYouNeedVATInvoice"),
        description: `<p>${t("pages.serviceSummary.VATInvoiceInfo")}</p>`,
        iconUrl: "invoice",
      },
    ],
    [cancellationRulesDescription, categoryType, t],
  );

  return (
    <Block marginTop={3}>
      <Typography variant="newH3">{t("screens.serviceSummary.importantInformation")}</Typography>
      <Block marginBottom={3} marginTop={2}>
        <CollapsibleChecklist custom checklist={cancellationDetails} />
      </Block>
    </Block>
  );
};

export default CancellationDetails;
